import { createContext, useContext } from "react";
/**
 * Create a side-effect-free context provider.
 */
class BlockerContextFactory {
  static Context() {
    return this.context = this.context || /*#__PURE__*/createContext({});
  }
}
BlockerContextFactory.context = void 0;
function useBlocker() {
  return useContext(BlockerContextFactory.Context());
}
export { BlockerContextFactory, useBlocker };